import React from 'react'
import { Box, Typography } from '@mui/material'
import { IPointTransaction } from '../../../types/leaderboardTypes'

interface PointTransactionCardProps {
  data: IPointTransaction
}

const PointTransactionCard: React.FC<PointTransactionCardProps> = ({
  data,
}) => {
  return (
    <Box
      p={{ xs: 1.5, md: 3 }}
      sx={{
        backgroundColor: data.color ? data.color : 'transparent',
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1, md: 2 },
        borderRadius: '12px',
        width: '100%',
        border: !data.color ? 2 : 'none',
        borderColor: !data.color ? 'grey.200' : 'none',
      }}
    >
      <Box
        component="img"
        src={`/images/leaderboard/${data.image}.png`}
        sx={{
          alignSelf: 'self-start',
        }}
      />
      <Box>
        <Typography variant="body1" mb={0.5}>
          {data.coin}
        </Typography>
        <Typography variant="subtitle2">{data.subtitle}</Typography>
      </Box>
    </Box>
  )
}

export default PointTransactionCard
